import React from 'react';

export function renderControlGroup (label, children) {
  return (
    <div className='control-group'>
      <div className='control-label'>{label}</div>
      <div className='controls'>
        {children}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/utils/ui.js